import { GlButton, GlButtonGroup, GlDisclosureDropdownItem } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { keyboardShortcutsDisabled } from '~/behaviors/shortcuts/shortcuts_disabled';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
export default {
    name: 'CodeDropdownIdeItem',
    components: {
        GlButton,
        GlButtonGroup,
        GlDisclosureDropdownItem
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        ideItem: {
            type: Object,
            required: true
        }
    },
    emits: [
        'close-dropdown'
    ],
    computed: {
        shortcutsDisabled () {
            return keyboardShortcutsDisabled();
        }
    },
    methods: {
        closeDropdown () {
            this.$emit('close-dropdown');
        },
        trackAndClose ({ action, label, additionalProperties } = {}) {
            if (action) {
                const payload = {
                    ...additionalProperties || {}
                };
                if (label) payload.label = label;
                this.trackEvent(action, Object.keys(payload).length ? payload : undefined);
            }
            this.closeDropdown();
        }
    }
};
